"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const inputCardRadio_1 = require("components/inputCardRadio");
const ModuleTypes_1 = require("./ModuleTypes");
const ModuleSelectItem_module_scss_1 = __importDefault(require("./ModuleSelectItem.module.scss"));
const ModuleSelectItem = ({ name, type, title, description, isChecked, disabled, tooltip, onChange }) => {
    const changeFormValue = (fieldName, newValue) => {
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name: fieldName, value: newValue } });
    };
    const afterChange = (moduleType) => {
        const isPaidModule = moduleType === ModuleTypes_1.ModuleType.Paid;
        const isExtraModule = moduleType !== ModuleTypes_1.ModuleType.Standard;
        if (isExtraModule) {
            changeFormValue('extra', isExtraModule);
            changeFormValue('paidModule', isPaidModule);
            changeFormValue('publicModule', false);
            return;
        }
        changeFormValue('extra', false);
        changeFormValue('paidModule', false);
    };
    const handleChange = ({ target }) => {
        const moduleType = target.value;
        changeFormValue(name, moduleType);
        afterChange(moduleType);
    };
    return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { content: tooltip, className: (0, classnames_1.default)(ModuleSelectItem_module_scss_1.default.container, '_w-full _pt-1'), children: (0, jsx_runtime_1.jsx)(inputCardRadio_1.InputCardRadio, { id: type, name: name, title: title, value: type, isChecked: isChecked, isDisabled: disabled, onChange: handleChange, children: description }) }));
};
exports.default = ModuleSelectItem;
